<template>
    <div class="Home-container">
        <Header backgroundColor="#222733"></Header>
        <div class="main">
            <div class="part1">
                <div class="part1-introduction">
                    <p class="title">苏州保泰信息科技有限公司</p>
                    <p class="contents">
                        专注于移动互联网商务服务和大数据资源整合、应用、开发、服务和运营的高新技术企业，专业提供搭建大数据应用与服务平台，以实现数据挖掘、数据整理、大数据分析、精准营销、跨领域数据融合、供应链重组与整合等各方面应用。
                    </p>
                    <router-link tag="span" to="Introduct" class="know-more">了解更多</router-link>
                </div>
                <div class="part1-core-technology">
                    <p class="title">核心技术</p>
                    <div class="items">
                        <img v-for="(item,index) in technologys" class="item" :key="index" :src="item" alt="">
                    </div>
                </div>
            </div>
            <div class="part2">
                <div class="part2-main">
                    <div class="part2-introduction">
                        <p class="title">基于大数据分析的精准用户推广</p>
                        <p class="contents">
                            已经构建符合自己特色的用户标签体系，建立17+维表；11大类超过106个标签与模型，拥有并基于spark大数据生态组建作为核心处理技术，对海量数据进行规整处理，刻画出用户画像体系，并不断迭代、丰富受众标签描述。在此基础上利用业务的正、负样本数据，使用TGI(Target Group Index)对受众行为偏好进行计算，找寻出最优质最符合条件的受众，为运营提供精准营销服务，实现千人千面的营销策略。
                        </p>
                    </div>
                    <div class="part2-imgs">
                        <div class="features">
                            <img v-for="(item,index) in features" :key="index" :src="item" alt="">
                        </div>
                        <img class="illustration" src="../../public/imgs/illustration.png" alt="">
                    </div>
                </div>
            </div>
            <div class="part3">
                <p class="title">保险类客户合作案例</p>
                <div class="insurances">
                    <img class="insurance" v-for="(item,index) in insurances" :key="index" :src="item" alt="">
                    <div class="insurance-div" v-for="r in divInsurances" :key="r.name" >
                        <p class="title">{{r.name}}</p>
                        <p class="remark">{{r.remark}}</p>
                    </div>
                </div>
            </div>
            <div class="part4">
                <p class="title">截止到目前保泰已拥有</p>
                <div class="items">
                    <div class="item" v-for="r in labels" :key="r.name" >
                        <img :src="r.img" alt="">
                        <p class="name">{{r.name}}</p>
                        <p class="remark">{{r.remark}}</p>
                    </div>
                </div>
                <div class="part4-main">
                    <p class="part4-main-title">让数据更智慧</p>
                    <p class="part4-main-contents">根据以上标签，到大数据中定向匹配用户，然后推送，再根据效果，取种子用户， 进行放大/约束，再次定向用户或者优化标签。</p>
                    <router-link tag="span" to="Contact" class="now-contact">马上联系我们</router-link>
                </div>
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '../components/Header'
    import Footer from '../components/Footer'

    const technologys = [require("../../public/imgs/CARD1.png"),require("../../public/imgs/CARD2.png"),require("../../public/imgs/CARD3.png"),]
    const features = [require("../../public/imgs/2.png"),require("../../public/imgs/3.png"),]
    const insurances = [require("../../public/imgs/icon-insurance-01.png"),require("../../public/imgs/icon-insurance-02.png"),require("../../public/imgs/icon-insurance-03.png"),require("../../public/imgs/icon-insurance-04.png"),require("../../public/imgs/icon-insurance-05.png"),require("../../public/imgs/icon-insurance-06.png"),require("../../public/imgs/icon-insurance-07.png"),require("../../public/imgs/icon-insurance-08.png"),require("../../public/imgs/icon-insurance-09.png"),require("../../public/imgs/icon-insurance-10.png"),require("../../public/imgs/icon-insurance-11.png"),require("../../public/imgs/icon-insurance-12.png"),]
    const divInsurances = [{name:"水滴保",remark:"新增保单成交3万单/月，成为该司最大的获客渠道"},{name:"微保",remark:"平均获客1000单/日，续费率达95%左右，成为短信资源中后程转化最优的渠道。"},{name:"泰康人寿",remark:"为泰康人寿高端养老社区引流有效用户500户/月，成为该品牌最强的获客渠道"},]
    const labels = [{name:"6亿",remark:"可分析且标签化用户",img:require("../../public/imgs/icon-lab-01.png")},{name:"2400个",remark:"现有标签库",img:require("../../public/imgs/icon-lab-02.png")},{name:"1.2亿/天",remark:"电商购物类用户",img:require("../../public/imgs/icon-lab-03.png")},{name:"2400万/天",remark:"金融银证类用户",img:require("../../public/imgs/icon-lab-04.png")},]

    export default {
        name: 'Home',
        data() {
            return {
                technologys,
                features,
                insurances,
                divInsurances,
                labels
            }
        },
        components: {
            Header,Footer
        },
        created() {
            this.$store.commit('changeNavs', 'Home')
        },
        methods: {

        },
        mounted() {

        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" type="text/less" scoped>
    .Home-container {
        position: relative;
        min-width: 1200px;
        background: url("../../public/imgs/BG1.png") no-repeat center top;
        background-size: 1440px 922px;
        .main {
            min-width: 1200px;
            .part1 {
                width: 1200px;
                margin: 0 auto;
                padding-bottom: 60px;
                padding-top: 60px;
                .part1-introduction {
                    width: 662px;
                    margin: 62px 10px 65px;
                    .title {
                        color: #fff;
                        font-size: 35px;
                    }
                    .contents {
                        color: #fff;
                        font-size: 20px;
                        line-height: 30px;
                        margin: 10px 0;
                    }
                    .know-more {
                        width: 173px;
                        height: 40px;
                        text-align: center;
                        line-height: 40px;
                        color: #5C6DDD;
                        font-size: 14px;
                        background-color: #fff;
                        display: block;
                        border-radius: 3px;
                        cursor: pointer;
                    }
                }
                .part1-core-technology {
                    .title {
                        color: #fff;
                        font-size: 44px;
                        text-align: center;
                        margin-bottom: 20px;
                    }
                    .items {
                        align-items: center;
                        display: flex;
                        justify-content: center;
                        .item {
                            width: 347px;
                            height: 416px;
                            display: block;
                            margin: 0 20px;
                        }
                    }
                }
            }
            .part2 {
                min-width: 1200px;
                background: url("../../public/imgs/BG2.png") no-repeat center top;
                background-size: 1440px 922px;
                .part2-main {
                    padding-top: 46px;
                    .part2-introduction {
                        width: 840px;
                        margin: 0 auto;
                        .title {
                            color: #fff;
                            font-size: 48px;
                            text-align: center;
                            margin-bottom: 30px;
                        }
                        .contents {
                            color: #fff;
                            font-size: 16px;
                            line-height: 30px;
                        }
                    }
                    .part2-imgs {
                        display: flex;
                        justify-content: center;
                        margin-top: 60px;
                        .features {
                            margin: 0 20px;
                            width: 560px;
                            img  {
                                width: 560px;
                                height: 279px;
                            }
                        }
                        .illustration {
                            width: 437px;
                            height: 376px;
                            margin: 0 20px;
                        }
                    }
                }
            }
            .part3 {
                padding: 90px 0 0;
                width: 1200px;
                min-width: 1200px;
                margin: 0 auto;
                .title {
                    color: #1D2128;
                    font-size: 48px;
                    font-weight:500;
                    line-height:67px;
                    height:67px;
                    text-align: center;
                }
                .insurances {
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    justify-content: center;
                    margin-top: 40px;
                    .insurance {
                        width: 322px;
                        height: 122px;
                        border-radius: 3px;
                        display: block;
                        margin-bottom: 25px;
                        &:nth-child(3n-1) {
                            margin: 0 67px 25px;
                        }
                    }
                    .insurance-div {
                        width: 300px;
                        margin-bottom: 25px;
                        padding: 0 12px;
                        &:nth-child(3n-1) {
                            margin: 0 67px 25px;
                        }
                        .title {
                            font-size:36px;
                        }
                        .remark {
                            font-size: 20px;
                            line-height: 30px;
                            width: 290px;
                            height: 150px;
                            margin: 0 auto;
                        }
                    }
                }
            }
            .part4 {
                background-color: #F6F6F6;
                padding: 90px 0;
                .title {
                    font-size: 48px;
                    color: #000;
                    height:67px;
                    font-family:PingFangSC-Semibold,PingFang SC;
                    font-weight:600;
                    text-align: center;
                    margin-bottom: 50px;
                }
                .items {
                    display: flex;
                    justify-content: center;
                    .item {
                        width: 250px;
                        margin: 0 10px;
                        img {
                            width: 250px;
                            height: 250px;
                        }
                        .name {
                            text-align: center;
                            color: #32325D;
                            font-size: 48px;
                            font-weight:500;
                            line-height:72px;
                            height: 72px;
                        }
                        .remark {
                            text-align: center;
                            color: #525F7F;
                            font-size: 20px;
                            line-height:30px;
                            height: 30px;
                            font-weight:400;
                        }
                    }
                }
                .part4-main {
                    margin: 100px auto 0;
                    background:linear-gradient(270deg,rgba(251,177,64,1) 0%,rgba(251,99,64,1) 100%);
                    box-shadow:0px 16px 48px 0px rgba(0,0,0,0.17);
                    border-radius:4px;
                    width:1011px;
                    height:239px;
                    position: relative;
                    padding: 50px 50px 30px 50px;
                    box-sizing: border-box;
                    .part4-main-title {
                        color: #fff;
                        font-size: 28px;
                        height: 42px;
                        line-height: 42px;
                        margin-bottom: 20px;
                    }
                    .part4-main-contents {
                        width: 555px;
                        color: #fff;
                        font-size: 20px;
                    }
                    .now-contact {
                        width: 206px;
                        height: 40px;
                        text-align: center;
                        line-height: 40px;
                        color: #212529;
                        font-size: 14px;
                        background-color: #fff;
                        display: block;
                        border-radius: 3px;
                        position: absolute;
                        top: 50%;
                        right: 50px;
                        transform: translateY(-50%);
                        cursor: pointer;
                    }
                }
            }
        }
    }
</style>
